
import ApiClient from '../ApiClient';

class AiCredentialsAPI extends ApiClient {
  constructor() {
    super('captain/ai_credentials', { accountScoped: true });
  }

  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/captain/ai_credentials`);
  }

  save(accountId, params) {
    return axios.post(`/api/v1/accounts/${accountId}/captain/ai_credentials`, params);
  }

  remove(accountId, provider) {
    return axios.delete(`/api/v1/accounts/${accountId}/captain/ai_credentials/${provider}`);
  }

  getOauthUrl(accountId, provider) {
    return axios.get(`/auth/ai_oauth/${provider}/authorize?account_id=${accountId}`);
  }
}

export default new AiCredentialsAPI();
